import { render, staticRenderFns } from "./RoommateCardMini.vue?vue&type=template&id=79e33278&scoped=true&"
import script from "./RoommateCardMini.vue?vue&type=script&lang=js&"
export * from "./RoommateCardMini.vue?vue&type=script&lang=js&"
import style0 from "./RoommateCardMini.vue?vue&type=style&index=0&id=79e33278&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e33278",
  null
  
)

export default component.exports